import { type ObjectValuesUnionType } from '../../../utils/typing';

export type BoomStepId = 'STEP_1' | 'STEP_2' | 'STEP_3' | 'STEP_4' | 'STEP_5';

export const BoomStepStatuses = Object.freeze({
  OPEN: 'OPEN',
  LOCKED: 'LOCKED',
  PENDING: 'PENDING',
  WON: 'WON',
});

export type BoomStepStatus = ObjectValuesUnionType<typeof BoomStepStatuses>;
